<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong >{{$t('personList')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
<!--                <CButton-->
<!--                    class="mr-1"-->
<!--                    size="sm"-->
<!--                    color="secondary"-->
<!--                >{{ $t("buttons.print") }}-->
<!--                </CButton>-->
<!--                <a href="/dashboard/users/add-user" target="_blank">-->
<!--                  <CButton-->
<!--                      class="mr-1"-->
<!--                      size="sm"-->
<!--                      color="dark"-->
<!--                  >-->
<!--                    <CIcon size="sm" name="cil-plus"></CIcon>-->
<!--                  </CButton>-->
<!--                </a>-->
              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>

            <CRow>
              <CCol col="3">
                <CSelect :options="[{label:this.$t('all'),value:0},{label:this.$t('persons'),value:1},{label:this.$t('sidebars.users'),value:2},{label:this.$t('sidebars.customers'),value:3},{label:this.$t('sidebars.suppliers'),value:4}]"
                    :value.sync="selected_status"
                         />
              </CCol>

            </CRow>
                <CDataTableFixed
                    :items="items_worker"
                    :fields="fields"
                    column-filter
                    @row-clicked="table_row_clicked"
                    :items-per-page="10"
                    hover
                    striped
                    sorter
                    border
                    height="300px"
                >
                  <template #row_id="{item,index}">

                    <td>
                      <p >{{ index + 1 }}</p>

                    </td>

                  </template>

                  <template #personCode="{item}">
                    <td>
                      <p v-if="item.personCode!=null" >{{ item.personCode }}</p>
                    </td>
                  </template>

                  <template #title="{item}">
                    <td>
                      <p v-if="item.title!=null" >{{ item.title }}</p>
                    </td>
                  </template>
                  <template #surName="{item}">
                    <td>
                      <p v-if="item.surName!=null" >{{ item.surName }}</p>
                    </td>
                  </template>
                  <template #email="{item}">
                    <td>
                      <p v-if="item.email!=null" >{{ item.email }}</p>
                    </td>
                  </template>
                  <template #jobProfile="{item}">
                    <td>
                      <p v-if="item.jobProfile!=null" >{{ item.jobProfile }}</p>
                    </td>
                  </template>
                  <template #branch="{item}">
                    <td>
                      <p v-if="item.branch!=null" >{{ item.branch }}</p>
                    </td>
                  </template>
                  <template #groupName="{item}">
                    <td>
                      <p v-if="item.groupName!=null" >{{ item.groupName }}</p>
                    </td>
                  </template>
                  <template #userName="{item}">

                    <td>
                      <p >{{ item.userName }}</p>

                    </td>

                  </template>


                  <template #saleMethodName="{item}">
                    <td>
                      <a href="javascript:void(0)" class="text-primary" v-on:click="edit_sale_method(item)"
                         v-if="item.saleMethodName != null">{{ item.saleMethodName }}
                        <CIcon name="cil-pencil"/>
                      </a>

                    </td>

                  </template>
                  <template #person="{item}">
                    <td class="text-center">
                        <CIcon  name="cil-check"/>
                    </td>
                  </template>
                  <template #worker="{item}">
                    <td class="text-center">
                        <CIcon :class="get_checkbox_color(item,'isWorker')" @click.native="open_edit_user(item)" name="cil-check"/>
                    </td>
                  </template>
                  <template #customer="{item}">
                    <td class="text-center">
                        <CIcon name="cil-check" :class="get_checkbox_color(item,'isCustomer')" @click.native="open_edit_customer(item)"/>
                    </td>
                  </template>
                  <template #supplier="{item}">
                    <td class="text-center">
                        <CIcon name="cil-check" :class="get_checkbox_color(item,'isVendor')" @click.native="open_edit_supplier(item)"/>
                    </td>
                  </template>

                  <template #operation="{item,index}">
                    <td class="py-2">
                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="goEditPerson(item)"
                      >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.documents')"
                               @click="goToDocuments(item)"
                      >
                        <CIcon name="cil-list-rich"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.commission')"
                               @click="goToPorsant(item)"
                      >
                        <CIcon name="cil-dollar"/>
                      </CButton>
                    </td>
                  </template>


                </CDataTableFixed>


          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="saleMethodModal"
        :no-close-on-backdrop="false"
        :centered="true"
        :title="$t('dialogs.editSaleMethod')"
        size="lg"
        color="dark"
    >
      <CSelect
          :options="method_list"
          :value.sync="selected_method"
          :label="$t('tables.saleMethod')"
      />
      <template #header>
        <h6 class="modal-title">{{ $t('dialogs.editSaleMethod') }}</h6>
        <CButtonClose @click="saleMethodModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="edit_person_sale_method(selected_method,selected_person)"
                 color="danger"
        >{{ $t("buttons.edit") }}
        </CButton>
        <CButton
            @click="saleMethodModal = false"
            color="success"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_exist: 0,
      selected_person: 0,
      selected_status:0,
      items_customer: [],
      fields: [
        {key: 'row_id',filter:false, label: this.$t('tables.row'), _style: 'width:5%'},
        {key: 'personCode', label: this.$t('personalNo'), _style: 'width:10%'},
        // {key: 'title', label: this.$t('title'), _style: 'width:5%'},
        {key: 'userName', label: this.$t('name'), _style: 'width:10%'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:10%'},
        {key: 'mobileNo', label: this.$t('mobile'), _style: 'width:10%'},
        {key: 'person',filter:false, label: this.$t('persons'), _style: 'width:10%'},
        {key: 'worker',filter:false, label: this.$t('sidebars.users'), _style: 'width:10%'},
        {key: 'customer',filter:false, label: this.$t('sidebars.customers'), _style: 'width:10%'},
        {key: 'supplier',filter:false, label: this.$t('sidebars.suppliers'), _style: 'width:10%'},
        // {key: 'jobProfile', label: this.$t('jobTitle'), _style: 'width:10%'},
        // {key: 'branch', label: this.$t('branch'), _style: 'width:10%'},
        // {key: 'groupName', label: this.$t('permission'), _style: 'width:10%'},
      ],

      items_worker: [],
      // fields,

      items_vendor: [],
      // fields,

      details: [],
      templates_items: [
        {template_id: 'One', name: 'A'},
        {template_id: 'Two', name: 'B'},
        {template_id: 'Three', name: 'C'}
      ],
      collapseDuration: 0,
      status_form: 0,
      table_clicks: 0,
      table_clicks_timer: null,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_method_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_status': function () {
      this.get_lists();
    } ,
    'selected_exist': function () {
      this.get_lists();
    }
  },
  methods: {
    open_edit_user(item){
      window.open('/dashboard/users/edit-user/' + item.userId)
    },
    open_edit_customer(item){
      window.open('/dashboard/sale-orders/edit-customer/' + item.userId)
    },
    open_edit_supplier(item){
      window.open('/dashboard/orders/edit-supplier/' + item.userId)
    },
    get_checkbox_color(item,id){
      if(item[id]){
        return 'text-success';
      }
      return '';
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 300);
      } else if (this.table_clicks > 1) {
        this.table_clicks = 0

        clearTimeout(this.table_clicks_timer);
        this.goEditPerson(item)

      }

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
    },
    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetPriceMethodTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.method_list = [];
          self.method_list = self.sort_array(
                  self.method_list, content_data.data,
                  'id','title');


          if (self.$route.params.area_id == null) {
            self.get_lists();

          } else {
            self.get_listsByArea();

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_person_sale_method(method,user_id){
this.saleMethodModal = false;
      let self = this;
      const formData = new FormData();
      let url;
      url = "EditPersonMethod";
      formData.append('MethodId', method);
      formData.append('PersonId',user_id);
      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        this.selected_method = '';
        this.selected_person = 0;

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetAllPersons";
if(this.selected_status==0){
  formData.append('IsVendor', false);
  formData.append('IsWorker', true);
  formData.append('IsCustomer', false);
  formData.append('IsActive', 0);

}if(this.selected_status==1){
  formData.append('IsVendor', false);
  formData.append('IsWorker', false);
  formData.append('IsCustomer', false);
  formData.append('IsActive', 0);
}
      if(this.selected_status==2){
        formData.append('IsVendor', false);
        formData.append('IsWorker', true);
        formData.append('IsCustomer', false);
        formData.append('IsActive', 0);
      }  if(this.selected_status==3){
        formData.append('IsVendor', false);
        formData.append('IsWorker', false);
        formData.append('IsCustomer', true);
        formData.append('IsActive', 0);
      }
    if(this.selected_status==4){
        formData.append('IsVendor', true);
        formData.append('IsWorker', false);
        formData.append('IsCustomer', false);
        formData.append('IsActive', 0);
      }

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.items_worker = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });

          if(self.selected_exist==1){
            self.items_worker = self.items_worker.filter(item => item.groupName != null);

          }
          if(self.selected_exist==2){
            self.items_worker = self.items_worker.filter(item => item.groupName == null);

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_listsByArea() {
      var self = this;


      const formData = new FormData();

      var url = "GetUsers";

      formData.append("area_id", this.$route.params.area_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
            return {...item, row_id}

// }
          });

          self.items_customer = self.items_customer.filter(item => item.isCustomer);

          self.items_vendor = content_data.data.map((item, row_id) => {
            // console.log(item.isVendor);
            // if(item.isVendor){
            return {...item, row_id}

            // }
          });
          self.items_vendor = self.items_vendor.filter(item => item.isVendor);

          self.items_worker = content_data.data.map((item, row_id) => {
            // if(item.isCustomer){
            return {...item, row_id}

            // }
          });
          self.items_worker = self.items_worker.filter(item => item.isWorker);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {
      window.open('/dashboard/users/edit-user/' + item.userId);

    },
    goToDocuments(item) {

      // this.$router.push({path: '/dashboard/documents/person-list/' + item.userId});
      window.open('/dashboard/documents/person-list/' + item.userId);

    },
    goToAccountingReport(item) {

      this.$router.push({path: '/dashboard/users/user-accounting-report/' + item.userId});

    },
    goToPorsant(item) {
      this.$router.push({path: '/dashboard/users/user-porsant/' + item.userId});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
